import React from "react";
import { Route, Routes } from "react-router-dom";
import ChecklistExecutionIndex from "../module/ChecklistExecution/checklistExecutionIndex";
import ConfigurationIndex from "../module/Configuration/configurationIndex";

function CheckListBuilderRoutes() {
  return (
      <Routes>
        <Route path="check-list/*" element={<ChecklistExecutionIndex />} />
        <Route path="configuration/*" element={<ConfigurationIndex />} />
      </Routes>
  );
}

export default CheckListBuilderRoutes;
